import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { PointsSummary } from 'src/app/models/community';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CommunityService } from 'src/app/services/community.service';
import { I18nService } from 'src/app/services/i18n.service';
import { DialogContentLogin } from '../header-sticky/login-dialog/dialog-content-login';
import { ACCOUNT_SECTIONS, AccountSectionId, formatDate, objectIdDate } from './account-sections';

const DEFAULT_AVATAR = 'assets/userAvatar.svg';

// Espace membre façon « Mon compte » : contenu sauvegardé, contributions, Points Club, boutique, statistiques, badges, expertise
@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MyAccountComponent implements OnInit, OnDestroy {

  readonly sections = ACCOUNT_SECTIONS;
  section: AccountSectionId = 'saved';
  isLoggedIn = false;
  user: User | null = null;
  points: PointsSummary | null = null;

  private subscriptions = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthService,
    private communityService: CommunityService,
    public i18n: I18nService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(this.route.paramMap.subscribe(params => {
      const section = params.get('section') as AccountSectionId;
      if (!this.sections.some(s => s.id === section)) {
        this.router.navigate(['/compte', 'saved'], { replaceUrl: true });
        return;
      }
      this.section = section;
    }));

    this.subscriptions.add(this.communityService.points$.subscribe(points => this.points = points));

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.subscriptions.add(this.authService.currentUser$.subscribe(user => {
      const wasLoggedIn = this.isLoggedIn;
      this.user = user;
      this.isLoggedIn = !!user;
      if (this.isLoggedIn && !wasLoggedIn) {
        this.communityService.loadPoints().subscribe({ error: () => { } });
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get avatar(): string {
    return this.user?.avatar || DEFAULT_AVATAR;
  }

  get memberSince(): string {
    return formatDate(objectIdDate(this.user?._id), this.i18n.current);
  }

  openLogin(): void {
    this.dialog.open(DialogContentLogin, { width: '550px' });
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/']);
  }
}
